var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.857 19.5v1.563c0 .517-.432.937-.964.937H3.964A.952.952 0 013 21.062V6.688c0-.517.432-.937.964-.937h2.893v11.563c0 1.206 1.01 2.187 2.25 2.187h6.75zm0-13.438V2h-6.75a.952.952 0 00-.964.938v14.374c0 .518.432.938.964.938h10.929c.532 0 .964-.42.964-.938V7h-4.179c-.53 0-.964-.422-.964-.938zm4.86-1.212l-2.649-2.575A.976.976 0 0017.386 2h-.243v3.75H21v-.237a.93.93 0 00-.282-.663z"
  }))));
}

export default SvgTemplates;